export const environment = {
  production: false,
  apiUrl: 'https://identitydataapidev.cordelllaw.com',
  azureAd: {
    clientId: 'a142ac2c-727a-4312-9d31-f1c65155ee21',
    tenantId: 'a3a79d12-cac2-4d4d-82a4-22eeb4946eda',
    redirectUri: 'https://identitydatadev.cordelllaw.com',
    apiScopes: [
      'api://cordellidentity-dev/identity.read',
      'api://cordellidentity-dev/identity.write',
    ]
  },
  showClaims: true,
};
